import {createStore, withProps} from '@ngneat/elf';

import {Session} from '@store/session/session.model';
import {withRequestsStatus} from '@ngneat/elf-requests';

export const sessionStore = createStore(
  {name: 'session'},
  withProps<Session>({}),
  withRequestsStatus(),
);